import styled from "styled-components";
import CompleteItem from "../img/Complete.svg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { nextPage, dataChange, backPage, nowPage, orderFin } from '../slices/counterSlice';
import { cardInsert } from "../api/order";
import mixpanel from "mixpanel-browser";

const ContentFrame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  @media (max-width: 767px) {
    padding-top: 20px;
  }
`;

const Complete = styled.img`
  width: 90px;
  margin-bottom: 50px;
  @media (max-width: 767px) {
    width: 48px;
    margin-bottom: 20px;
  }
`;

const CompleteText01 = styled.div`
  margin-bottom: 40px;
  font-family: Gongim-Medium;
  font-size: 40px;
  color: #222;
  @media (max-width: 767px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

const CompleteText02 = styled.div`
  margin-bottom: 8px;
  font-family: Gongim-Reguler;
  font-size: 28px;
  color: #707070;
  @media (max-width: 767px) {
    font-size: 16px;
    margin-bottom: 4px;
  }
`;

const CompleteText03 = styled.div`
  font-family: Gongim-Reguler;
  font-size: 24px;
  color: #707070;
  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

const ButtonLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 60px 0 80px 0;
  @media (max-width: 1099px) {
    gap: 10px;
    padding: 36px 0;
  }
`;

const ButtonRed = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eb3f3d;
  color: #fff;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

export default function Content04() {
  let data = useSelector((state) => state.counter.data.data);
  let orderNo = useSelector((state) => state.counter.data.orderNo);
  let cardData = useSelector((state) => state.counter.data.cardData);
  let PDcardData = useSelector((state) => state.counter.data.PDcardData);
  let PD = useSelector((state) => state.counter.data.assignType);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const path = useLocation();

  if (data.user.phoneNo === '' || orderNo === 0) {
    window.location.replace('/')
    // history.go(-1)
  } else {
    if (PD === 2) {
      cardInsert(cardData).then(res => {
        // dispatch(orderFin());
      }).catch(err => {
        console.log(err)
      })
      cardInsert(PDcardData).then(res => {
        dispatch(orderFin());
      }).catch(err => {
        console.log(err)
      })
    } else {
      cardInsert(cardData).then(res => {
        dispatch(orderFin());
      }).catch(err => {
        console.log(err)
      })
    }
  }
  dispatch(nowPage(path.pathname));

  const winOpen = () => {
    const host = window.location.host; //도메인 감지
    const parts = host.split('.');
    mixpanel.track("오더상세정보페이지 이동버튼 클릭");
    if(host === 'gongim.cardelivery.co.kr') {
      if(PD === 2) {
        window.open(`https://gongim.cardelivery.co.kr/driveloc/${orderNo-1}`);
      } else {
        window.open(`https://gongim.cardelivery.co.kr/driveloc/${orderNo}`);
      }
    } else if (host === 'gongim.dev.cardelivery.co.kr'){
      if(PD === 2) {
        window.open(`https://gongim.dev.cardelivery.co.kr/driveloc/${orderNo-1}`);
      } else {
        window.open(`https://gongim.dev.cardelivery.co.kr/driveloc/${orderNo}`);
      }
    } else {
      if(PD === 2) {
        window.open(`http://localhost:3001/driveloc/${orderNo-1}`);
      } else {
        window.open(`http://localhost:3001/driveloc/${orderNo}`);
      }
    }
  }

  return (
    <ContentFrame>
      <Complete src={CompleteItem} />
      <CompleteText01>주문이 정상적으로 접수 되었습니다.</CompleteText01>
      <CompleteText02>기사님을 찾고 있습니다.</CompleteText02>
      <CompleteText03>
        (배차가 완료되면, 카카오 알림 메세지를 발송합니다)
      </CompleteText03>
      <ButtonLine>
        <ButtonRed onClick={() => {winOpen()}}>확인</ButtonRed>
      </ButtonLine>
    </ContentFrame>
  );
}
